import { Header, HeaderName, Theme } from '@carbon/react';

const TopNavSimple = () => {
  return (
    <>
      <Theme theme="g90">
        <div
          style={{
            '--cds-background': '#171717',
          }}
        >
          <Header aria-label="CircuitBread Insights">
            <HeaderName href="/" prefix="">
              <div className="flex items-center gap-2 no-underline text-[#f4f4f4]">
                <img
                  src="/img/cb-logo-black.png"
                  alt="CircuitBread Logo"
                  className="h-6 w-auto"
                  loading="eager"
                  decoding="sync"
                />
                <span>CircuitBread Insights</span>
              </div>
            </HeaderName>
          </Header>
        </div>
      </Theme>
    </>
  );
};

export default TopNavSimple;
